import axios from "axios";
import { checkEmailValidityURL } from "../utils/constants";

const checkEmailValidity = email => {
    return axios.get(checkEmailValidityURL, { params: { email: email } });
};

export { checkEmailValidity };
